'use strict';
import util from './util';



/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
export default function () {
	/**
	 * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
	 * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
	 */
	if (!SitePreferences.CONSENT_TRACKING_HINT && SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
		// check for privacy policy page
		if ($('.privacy-policy').length === 0) {
			$.get(util.appendParamsToUrl(Urls.cookieHint, {
				"format": "ajax"
			}), function (data) {
				$(document).find('body #main').append("<div class='cookie_consent_popup'>" + data + "</div>");
				$(document).find('.cookie_consent_popup .agreeButton').on('click', function () {
					$('.cookie_consent_popup').remove();					
				});
				enableCookies();
				
				
			});
		}
	} else {
		// Otherwise, we don't need to show the asset, just enable the cookies
		enableCookies();
	}

	function enableCookies() {
		if (document.cookie.indexOf('dw=1') < 0) {
			document.cookie = 'dw=1; path=/';
		}
		if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
			document.cookie = 'dw_cookies_accepted=1; path=/';
			
			//cookie consent for newsletter pop in  
	  	    util.setCookie(Constants.COOKIENAME_COOKIECONSENT_FLAG, true, newsletterCookieDuration);
		}
		
		
	}
};